import { lazy } from 'react';

export const LazyAgenda = lazy(() => 
  import('@/pages/Agenda').then(module => ({ default: module.Agenda }))
);
